var _ellipse, _ellipse2, _g, _g2, _g3, _path, _ellipse3, _path2, _ellipse4, _ellipse5, _path3, _ellipse6, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 198,
    viewBox: "0 0 208 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2,
    cy: 79.2003,
    rx: 79.2,
    ry: 79.2003,
    transform: "matrix(-0.965926 0.25882 -0.258818 -0.965926 208 156.988)",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10493_2342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 21,
    width: 160,
    height: 160
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2,
    cy: 79.2003,
    rx: 79.2,
    ry: 79.2003,
    transform: "matrix(-0.965926 0.25882 -0.258818 -0.965926 208 156.988)",
    fill: "#EBEBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10493_2342)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10493_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.681 32.1647L97.2608 31.7812L95.5348 27.7174C95.2243 26.9777 94.165 26.9777 93.8545 27.7174L92.1285 31.7903L87.7177 32.1647C86.9141 32.2286 86.5854 33.2332 87.1972 33.7628L90.5487 36.6668L89.5442 40.9772C89.3615 41.7626 90.2108 42.3835 90.9048 41.9635L94.6946 39.6804L98.4845 41.9726C99.1785 42.3927 100.028 41.7717 99.8451 40.9863L98.8406 36.6668L102.192 33.7628C102.804 33.2332 102.484 32.2286 101.681 32.1647Z",
    fill: "#FF5000"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10493_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.004 5.25371L132.192 5.00962L131.093 2.42338C130.896 1.95262 130.222 1.95262 130.024 2.42338L128.926 5.01543L126.119 5.25371C125.607 5.29439 125.398 5.93369 125.788 6.27077L127.92 8.11892L127.281 10.8621C127.165 11.3619 127.705 11.7571 128.147 11.4897L130.559 10.0368L132.97 11.4956C133.412 11.7629 133.952 11.3677 133.836 10.8679L133.197 8.11892L135.33 6.27077C135.719 5.93369 135.516 5.29439 135.004 5.25371Z",
    fill: "#FF5000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.138 180.849C180.741 173.5 180.964 164.385 180.174 160.874L182.323 160.387C183.248 164.495 182.932 174.453 174.666 182.442C172.211 184.816 169.749 186.095 167.408 186.519C166.709 187.771 165.761 188.937 164.556 189.922C160.473 193.262 153.689 194.375 144.097 190.41L144.936 188.365C154.077 192.143 159.922 190.859 163.164 188.208C163.751 187.728 164.26 187.198 164.696 186.634C163.123 186.479 161.691 185.94 160.46 185.162C158.668 184.032 157.289 182.393 156.479 180.664C155.678 178.954 155.379 177.028 155.968 175.374C156.493 173.898 157.345 172.759 158.442 172.051C159.544 171.339 160.824 171.108 162.101 171.34C164.638 171.8 166.994 174.023 168.322 177.569C169.03 179.462 169.092 181.734 168.472 183.943C169.923 183.411 171.495 182.436 173.138 180.849ZM165.961 184.461C166.848 182.345 166.908 180.081 166.259 178.347C165.102 175.258 163.235 173.794 161.709 173.517C160.955 173.38 160.245 173.517 159.634 173.911C159.018 174.309 158.436 175.014 158.043 176.118C157.713 177.046 157.828 178.345 158.473 179.723C159.11 181.082 160.21 182.392 161.632 183.29C162.867 184.068 164.334 184.532 165.961 184.461Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.351,
    cy: 159.525,
    rx: 4.77515,
    ry: 4.42453,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.735 142.934L174.121 138.141C178.529 120.445 164.204 103.731 156.49 97.5858C153.674 102.133 146.352 108.499 139.593 97.5858C132.835 86.6728 135.553 80.2578 137.757 78.4145C141.552 75.0963 152.523 71.262 166.04 82.47C182.937 96.48 191.385 130.399 189.916 145.884C188.741 158.271 177.182 163.58 171.55 164.686L162.735 142.934Z",
    fill: "#526775"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.92271,
    cy: 13.6788,
    rx: 6.92271,
    ry: 13.6788,
    transform: "matrix(0.869606 -0.493747 0.490982 0.87117 130.558 83.0381)",
    fill: "#354550"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.72915,
    cy: 12.2488,
    rx: 6.72915,
    ry: 12.2488,
    transform: "matrix(0.869606 -0.493747 0.490982 0.87117 155.876 146.261)",
    fill: "#354550"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.119 142.934C179.825 141.459 175.833 139.124 173.874 138.141C176.519 134.306 174.242 124.254 172.772 119.707C177.474 125.9 179.629 137.772 180.119 142.934Z",
    fill: "#354550"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10493_2342",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 21,
    width: 160,
    height: 160
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.2,
    cy: 79.2003,
    rx: 79.2,
    ry: 79.2003,
    transform: "matrix(-0.965926 0.25882 -0.258818 -0.965926 208 157.003)",
    fill: "#EBEBEB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10493_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 109.457C14 107.8 15.3431 106.457 17 106.457H125.074C126.731 106.457 128.074 107.8 128.074 109.457V170.615L128.39 180.77C128.465 183.172 125.827 184.683 123.793 183.402L104.222 171.077C103.743 170.775 103.189 170.615 102.623 170.615H17C15.3431 170.615 14 169.272 14 167.615V109.457Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.6677,
    y: 133.108,
    width: 74.7383,
    height: 3.9485,
    rx: 1.97425,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6677,
    y: 144.953,
    width: 45.2364,
    height: 3.9485,
    rx: 1.97425,
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10493_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 120.825L111.822 119.937L62.6898 88.8372L14 120.825Z",
    fill: "#E0DFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 120.825L23.2952 120.825L62.6897 88.8372L13.9999 120.825Z",
    fill: "#CBCACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.822 119.937L102.527 119.937L62.6897 87.9485L111.822 119.937Z",
    fill: "#CBCACD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0503 93.7241L14 120.825L14.4426 67.0674L56.0503 93.7241Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2146 93.7241L111.822 119.936V67.0674L70.2146 93.7241Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.822 67.0674H14.4429L63.1327 98.6111L111.822 67.0674Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10493_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.87 47.6157L134.65 47.0759L132.221 41.3565C131.784 40.3154 130.293 40.3154 129.856 41.3565L127.427 47.0887L121.219 47.6157C120.088 47.7056 119.625 49.1194 120.486 49.8649L125.203 53.952L123.789 60.0184C123.532 61.1237 124.728 61.9977 125.704 61.4065L131.038 58.1933L136.372 61.4193C137.349 62.0106 138.544 61.1366 138.287 60.0313L136.873 53.952L141.59 49.8649C142.451 49.1194 142.001 47.7056 140.87 47.6157Z",
    fill: "#FF5000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10493_2342",
    x: 0,
    y: 63.0674,
    width: 125.823,
    height: 81.7578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10493_2342"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10493_2342",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10493_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.7358,
    y: 23.9092,
    width: 21.917,
    height: 21.9171,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10493_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.585,
    width: 13.9472,
    height: 13.9472,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10493_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.615,
    y: 35.9971,
    width: 30.8461,
    height: 30.8462,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDuplicate);
export default __webpack_public_path__ + "static/media/phoneDuplicate.1c39e16d89e97ae4e03766915f5d2f9e.svg";
export { ForwardRef as ReactComponent };